# frozen_string_literal: true

module Engine
  module Action
    class PurchaseTrain < Base
    end
  end
end
